import module from '../module';

class OrderHistoryService {
    static $inject = [ '$http', 'cartonomyConfig' ];

    constructor(httpService, cartonomyConfig) {

        this._httpService = httpService;
        this._urlBase = cartonomyConfig.ApiV2 + 'order';
    }

    async getDetails(id) {
        return (await this._httpService.get(this._urlBase + '/' + id)).data;
    }

    async getHistory() {
        return (await this._httpService.get(this._urlBase)).data;
    }
}

module.factory('OrderHistoryService', OrderHistoryService);



// WEBPACK FOOTER //
// ./src/modules/profile/services/OrderHistoryService.js